const BREAKPOINT = 800;
const EMAIL = "hi@parallellab.co";
const MAIL_TO_EMAIL = `mailto:${EMAIL}`;

export { BREAKPOINT, EMAIL, MAIL_TO_EMAIL };
